function reverseObject(object) {
    var newObject = {};
    var keys = [];
    for (var key in object) {
        keys.push(key);
    }
    for (var i = keys.length - 1; i >= 0; i--) {

        var value = object[keys[i]];
        newObject[keys[i]] = value;
    }

    return newObject;
}

const state = {
    labels: []
}
const mutations = {
    'SET_LABELS'(state, labels) {
        state.labels = labels;
    },
    'SET_LINE_FONT'({commit}, {labelId, font}) {
        const record = state.labels.find(element => element.id == labelId);
        if (record) {
            if (typeof (record.lines) != "undefined") {
                record.lines.forEach(function (element) {
                    element.font = font;
                });
            }
        }
    },
    'SET_CLIPART_URL'({commit}, {labelId, clipartItem}) {
        const record = state.labels.find(element => element.id == labelId);
        if (!parseInt(clipartItem.no_icon)) {
            record.use_icon = 1;
        } else {
            record.use_icon = 0;
        }
        if (record.cliparts_blocks.length) {
            setTimeout(function () {
                store.dispatch('setMasterText', {labelId: labelId});
            }, 300);

            if (record) {
                record.cliparts_blocks.forEach(function (element) {
                    element.url = clipartItem.url;
                    element.category = clipartItem.category;
                    element.filename = clipartItem.filename;
                });
            }
        }

    },
    'SET_LINE_COLOR'({commit}, {record, colorId, secondColor}) {
        if (record) {

            if (typeof (record.defaultEditorColors[colorId]) != "undefined") {
                record.lines.forEach(function (linerecord) {
                    if (parseInt(linerecord.isSecondColor) && typeof (record.defaultEditorColors[secondColor]) != "undefined") {
                        linerecord.rgb = record.defaultEditorColors[secondColor].rgb;
                        linerecord.cmyk = record.defaultEditorColors[secondColor].cmyk;
                        linerecord.colorid = secondColor;
                    } else {
                        linerecord.rgb = record.defaultEditorColors[colorId].rgb;
                        linerecord.cmyk = record.defaultEditorColors[colorId].cmyk;
                        linerecord.colorid = colorId;
                    }
                });
            }
        }
    },
    'SAVE_FRAME'({commit}, {single, prod_id}) {
        var _data = {'labels': state.labels, selection: $jQuery('#current_selection_id').val(), 'prod_id': prod_id}
        if (single) {
            _data['labels'] = state.labels[0];
        }
        $jQuery('body').addClass('loader')
        $jQuery('.label_loader').show();
        $jQuery.ajax({
            type: "POST",
            dataType: "json",
            data: _data,
            url: store.getters.strings.saveLabelsUrl,
            success: function (data) {
                if (data.success) {
                    if (data.url) {
                        window.location = data.url;
                    }
                } else {
                    alert(data.message);
                }
                $jQuery('.label_loader').hide()
                $jQuery('body').removeClass('loader')
            }
        });
    },
    'GENERATE_PREVIEW'({commit}) {
        $jQuery('.label_loader').show();
        $jQuery('body').addClass('loader')
        var _allData = [];
        var toSend = {};
        var labels = state.labels;
         var labelx = state.labels[0];
        if (edit_type != "cart" && edit_type != "order") {
            var newSelection = "prod_" + product_id + "_" + labelx.templateid + ((Date.now())) + "_" + Math.floor(Math.random() * 10);
            $jQuery('#current_selection_id').val(newSelection);
        }
        labels.forEach(function (label) {

            var masterBlock = {};
            var text = "";
            var l = [];
            var _data = {}
            var totalLines = 0;
            label.lines.forEach(function (element) {
                if (parseInt(element.masterBlock)) {
                    if (!parseInt(label.use_icon) && parseInt(element.master_type))
                        masterBlock = element;

                    if (parseInt(label.use_icon) && !parseInt(element.master_type) && !Object.keys(masterBlock).length)
                        masterBlock = element;
                } else {
                    _data[element.block_name + '_properties'] = {
                        fontname: element['font'],
                        movable: parseInt(label.use_master_block) && !element.copy.length ? 1 : 0,
                        fillcolor: element['cmyk'],
                        colorspace: /*element['colorspace']*/ 'DeviceCMYK',
                        charspacing: element['charspacing'],
                        fontsize: element['fontsize'],
                        valignment: 'bottom',
                        /* alignment       : ! parseInt( label.use_master_block ) ? element['alignment'] : 'left',*/
                        alignment: 'left',
                        from_template: 0,
                        text_block_type: 'textflow',
                    }
                    /*    if(!element.masterBlock){
                             text+="<fontsize=" + element['fontsize'] + ">" + element.text+"\n";
                        }*/
                    if (element.text.length) {
                        _data[element.block_name] = element.text;
                    } else {
                        if (element.placeholder.length)
                            _data[element.block_name] = "";
                    }
                }
            });
            var isCompleted = 0;

            if (parseInt(label.use_master_block)) {
                label.lines.reverse().forEach(function (element) {
                    if (!parseInt(element.masterBlock) && !element.copy.length) {
                        totalLines++;
                        if (element.text.length > 0 || element.placeholder.length) {
                            isCompleted = 1;
                        }
                        if (isCompleted) {
                            l.push({'block_name': element.block_name, fontsize: element.fontsize, 'top': element.top, alignment: element.alignment, 'uniqueId': element.uniqueId, 'page_resize_percentageH': element.page_resize_percentageH, 'topAdjust': element.topAdjust});
                        }
                    }
                });

                label.lines.reverse()
                var no_lines = l.length;
                var line_procent = 100 / totalLines;
                var editprocent = line_procent * no_lines;
                var emptyProcent = 100 - editprocent;
                var top = 0;
                l.forEach(function (element, index) {
                    top = emptyProcent / 2 + (line_procent / 2) + (line_procent * index);
                    var realTop = parseFloat(masterBlock['pdf_height'] - (masterBlock['pdf_height'] * masterBlock.top / masterBlock['page_height']) - (masterBlock['pdf_height'] * masterBlock['height'] / masterBlock['page_height'])) + parseFloat(masterBlock['TrimBoxW']);

                    var masterDiv = $jQuery('#' + masterBlock['uniqueId']);
                    masterDiv.addClass('visible');
                    var span = masterDiv.find('span.' + label.uniqueId + element.block_name);
                    var masterBounding = masterDiv.get(0).getBoundingClientRect();
                    var rw = parseFloat(masterBlock.page_resize_percentageW) / 100;
                    var rh = parseFloat(masterBlock.page_resize_percentageW) / 100;
                    if (span.length) {
                        var page = span.parents('.page');
                        var scale = page.data('scale');
                        if (typeof (scale) == "undefined") {
                            scale = 1;
                        }
                        var spanBounding = span.get(0).getBoundingClientRect();
                        var pageBlockContainerBounding = span.parents('.page_blocks_container').get(0).getBoundingClientRect();

                        span.addClass('removeDisplay');
                        var cbGetter = $jQuery("#cbGetter");
                        cbGetter.html((span.text()));
                        cbGetter.css({
                            'font-family': '"' + element.font + '"',
                            'font-size': element.fontsize + "pt"
                        });
                        var cbGetterBounding = cbGetter.get(0).getBoundingClientRect();
                        var diff = (spanBounding.height - cbGetterBounding.height * rh) / 2;
                        var bottomText = (pageBlockContainerBounding.bottom - spanBounding.bottom) / scale + diff;
                        var params = {
                            font: element.font,
                            font_size: element.fontsize
                        };
                        var fontF = getFontForge(params);
                        var topText = bottomText + fontF.bottom / scale;
                        var diffLeft = 0
                        if(masterBlock['alignment'] == "center"){
                            diffLeft= (masterBounding.width/scale - cbGetterBounding.width * rw) / 2;
                        }
                        var textLeft = (spanBounding.left - pageBlockContainerBounding.left)/scale+ diffLeft  ;
                        var newTop = parseFloat(masterBlock['pdf_height']) * topText / parseFloat(masterBlock['page_height']) + parseFloat(masterBlock['TrimBoxW'])
                        var newTopPDF = parseFloat(parseFloat(masterBlock['pdf_height']) - (parseFloat(masterBlock['pdf_height']) * (parseFloat(masterBlock['top']) + span.position().top / scale) / parseFloat(masterBlock['page_height'])) - (parseFloat(masterBlock['pdf_height']) * (span.get(0).getBoundingClientRect().height / scale / ((parseFloat(element.page_resize_percentageH)) / 100)) / parseFloat(masterBlock['page_height']))) + parseFloat(masterBlock['TrimBoxW']);
                        var realLeft = parseFloat(parseFloat(masterBlock['pdf_width']) * (textLeft) / parseFloat(masterBlock['page_width'])) + parseFloat(masterBlock['TrimBoxH']);
                        span.removeClass('removeDisplay');
                        var heightSpan = (span.get(0).getBoundingClientRect().height / scale) / ((parseFloat(element.page_resize_percentageH)) / 100);
                        var newTopPDF = parseFloat(parseFloat(masterBlock['pdf_height']) - (parseFloat(masterBlock['pdf_height']) * (parseFloat(masterBlock['top']) + span.position().top / scale) / parseFloat(masterBlock['page_height'])) - (parseFloat(masterBlock['pdf_height']) * (span.get(0).getBoundingClientRect().height / scale / ((parseFloat(element.page_resize_percentageH)) / 100)) / parseFloat(masterBlock['page_height']))) + parseFloat(masterBlock['TrimBoxW']);
                        var realLeftPdflib = parseFloat(masterBlock['pdf_width'] * masterBlock.left / masterBlock['page_width']) + parseFloat(masterBlock['TrimBoxH']);
                        var pblockHeight = parseFloat(masterBlock['pdf_height'] * heightSpan / masterBlock['page_height']).toFixed(2);
                    } else {
                        var newTop = 0;
                        var newTopPDf = 0;
                        var realLeft = 0;
                        var realLeftPdflib = 0;
                        var pblockHeight = 0;
                        var scale = 1;
                    }

                    //var topAdjust =
                    element.realLeft = realLeft;
                    element.realTop = newTop;
                    element.pblockHeight = pblockHeight;
                    var heightSpan = (span.get(0).getBoundingClientRect().height / scale) / ((parseFloat(element.page_resize_percentageH)) / 100);
                    _data[element.block_name + '_properties']['top'] = newTopPDF - element.topAdjust;
                    //_data[element.block_name + '_properties']['top'] = realTop + ((masterBlock['pdf_height'] * masterBlock['height'] / masterBlock['page_height']) * top) / 100 - ((masterBlock['pdf_height'] * $jQuery( "." + label.uniqueId + element.block_name ).height() / masterBlock['page_height']) * 50) / 100;
                    _data[element.block_name + '_properties']['left'] = realLeft;
                    _data[element.block_name + '_properties']['left'] = realLeftPdflib;
                    _data[element.block_name + '_properties']['pblockHeight'] = pblockHeight;
                    _data[element.block_name + '_properties']['fontname'] = masterBlock['font'];
                    _data[element.block_name + '_properties']['width'] = parseFloat(parseFloat(masterBlock['pdf_height']) * parseFloat(masterBlock['width']) / parseFloat(masterBlock['page_height'])).toFixed(2);
                    //  _data[element.block_name + '_properties']['height'] = masterBlock['height'];
                    _data[element.block_name + '_properties']['height'] = parseFloat(parseFloat(masterBlock['pdf_height']) * heightSpan / parseFloat(masterBlock['page_height'])).toFixed(2);
                    masterDiv.removeClass('visible')
                });
            }
            _data['local_images'] = {};
            label.foregrounds.forEach(function (element) {
                if (typeof (element['imagePath']) && element['imagePath'] != "") {
                    _data[element.block_name + '_properties'] = {
                        image_block_type: 'image',
                        local_images: 1
                    }
                    _data['local_images'][element['block_name']] = element['imagePath'];
                    _data[element.block_name] = element['imagePath'];
                }
            });
            label.backgrounds.forEach(function (element) {
                if (typeof (element['imagePath']) && element['imagePath'] != "") {
                    _data[element.block_name + '_properties'] = {
                        image_block_type: 'image',
                        local_images: 1
                    }
                    _data['local_images'][element['block_name']] = element['imagePath'];
                    _data[element.block_name] = element['imagePath'];
                }
            });
            _data['image'] = {};
            if (typeof (label.cliparts_blocks) != "undefined") {
                label.cliparts_blocks.forEach(function (element) {
                    if (typeof (element.category) != "undefined" && typeof (element.category) != "") {
                        _data[element.block_name + '_properties'] = {
                            image_block_type: 'graphics',
                            category: element.category,
                            filename: element.filename,
                            rgb: element.rgb,
                            isGraphic: 1,
                        }

                        _data['image'][element['block_name']] = element.category + "/items/" + element.filename;
                        _data[element.block_name] = element.category + "/items/" + element.filename;
                    }
                });
            }

            _data['selection'] = $jQuery('#current_selection_id').val();
            _data['id'] = label.templateid;
            // _data['labels'] = state.labels;
            _data['stocks'] = store.getters.stocks;
            _data['edit_type'] = edit_type;
            _data['order_id'] = order_id;
            _data['item_id'] = item_id;
            _allData.push(_data);
        });
        toSend.data = _allData;
        toSend.labels = state.labels;
        if (edit_type == 'order') {
            $jQuery('body').addClass('loader')
            $jQuery('.label_loader').show();
            toSend['edit_order_data'] = $jQuery("#product_addtocart_form").serialize();
        }
        $jQuery.ajax({
            type: "POST",
            dataType: "json",
            data: toSend,
            url: store.getters.strings.urlPreview,
            success: function (data) {
                if (data.success) {
                    if (edit_type == "order") {
                        parent.postMessage("myevent", "*")
                        return;
                    }
                    labels.forEach(function (label) {
                        if (typeof (label.current_qty) != "undefined")
                            $jQuery('#qty').val(label.current_qty);
                    });
                    if (store.getters.strings.crosselings.length && edit_type != "cart" && edit_type != 'order') {
                        var form = $jQuery("#product_addtocart_form");
                        $jQuery.ajax({
                            url: form.attr('action'),
                            data: form.serialize() + '&isAjax=1&returnItem=1',
                            type: 'post',
                            dataType: 'json',
                            beforeSend: function () {

                            },
                            success: function (res) {

                                if (typeof (res.error) != "undefined") {
                                    $jQuery(".messagesCustom").show();
                                    window.scrollTo(0, 0);
                                    return false;
                                }


                                var event;
                                if (typeof (Event) === 'function') {
                                    event = new Event('updateCustomDataAjaxComplete');
                                } else {
                                    event = document.createEvent('Event');
                                    event.initEvent('updateCustomDataAjaxComplete', true, true);
                                }
                                document.dispatchEvent(event);

                                if (res.item_id) {
                                    item_id = res.item_id;
                                    edit_type = "update";
                                    var form = $jQuery("#product_addtocart_form");
                                    form.attr('action', update_url + item_id + "/");
                                }
                                if (store.getters.strings.crosselings.length) {
                                    var params = {
                                        status: 1
                                    };
                                    store.dispatch('setStatus', params);
                                    setTimeout(function () {
                                        var event;
                                        if (typeof (Event) === 'function') {
                                            event = new Event('resizeCustom');
                                        } else {
                                            event = document.createEvent('Event');
                                            event.initEvent('resizeCustom', true, true);
                                        }
                                        window.dispatchEvent(event)
                                    }, 200)

                                }

                            }
                        });
                    } else {
                        $jQuery("#product_addtocart_form").submit();
                    }
                } else {
                    alert(data.message);
                }
                $jQuery('.label_loader').hide();
                $jQuery('body').removeClass('loader');
            }
        });
    },
    'SET_SVG_COLOR'({commit}, {record, colorId}) {
        if (record) {
            if (typeof (record.defaultEditorColors[colorId]) != "undefined") {
                if (typeof (record.cliparts_blocks) != "undefined") {
                    record.cliparts_blocks.forEach(function (element) {
                        element.rgb = record.defaultEditorColors[colorId].rgb;
                        element.bgcolorid = colorId;
                    });
                }
            }
        }
    },
    'SET_BACKGROUND_COLOR'({commit}, {record, backColorId}) {
        if (record) {
            const recordActiveColor = record.print_options['colors'].options.find(element => element.isActive == 1)
            if (recordActiveColor) {
                record['current_color'] = backColorId;
                record.backgrounds.forEach(function (element) {
                    element.bgcolorid = backColorId;
                    element.imagePath = record.back_images['colors'][backColorId + recordActiveColor['code']];
                    element.imagePathProduction = record.back_images['colors_production'][backColorId + recordActiveColor['code']];
                });
                record.foregrounds.forEach(function (element) {
                    element.bgcolorid = backColorId;
                    element.imagePath = record.back_images['foreground_image'][backColorId + recordActiveColor['code']];
                    element.imagePathProduction = record.back_images['colors_production'][backColorId + recordActiveColor['code']];
                });
                if (typeof (record.back_images['static'][backColorId + recordActiveColor['code']]) != "undefined") {
                    var staticColor = record.back_images['static'][backColorId + recordActiveColor['code']];
                    if (typeof (record.back_images['second_color']) != "undefined") {
                        var secondColor = record.back_images['second_color'][backColorId + recordActiveColor['code']];
                    } else {
                        var secondColor = staticColor;
                    }
                    this.commit('SET_LINE_COLOR', {
                        record: record,
                        colorId: staticColor,
                        secondColor: secondColor
                    });
                }
                if (typeof (record.back_images['svg_static'][backColorId + recordActiveColor['code']]) != "undefined") {
                    var staticColor = record.back_images['svg_static'][backColorId + recordActiveColor['code']];
                    this.commit('SET_SVG_COLOR', {
                        record: record,
                        colorId: staticColor
                    });
                }
            }
        }
    },
    'CHANGE_FORMAT'({commit}, {labelId, formatCode}) {
        var record = state.labels.find(element => element.id == labelId);
        return;
        if (record) {
            if (typeof (record.formats[formatCode]) != "undefined") {

                record = record.formats[formatCode];
            }
        }
    },
    'SET_LABEL_READY'({commit}, {data, labelId}) {
        if (typeof (labelId) != "undefined") {
            const record = state.labels.find(element => element.id == labelId);
            if (record) {
                record.pq_quantities = data.pq_quantities[record.part];
                record.isReady = 1
            }
        } else {
            if (!$jQuery.isEmptyObject(data.pq_quantities)) {
                Object.keys(data.pq_quantities).forEach(function (part) {
                    const record = state.labels.find(element => element.part == part);
                    if (record) {
                        record.pq_quantities = data.pq_quantities[record.part];
                    }
                });
            }
        }
    },
    'SET_SHOW_MESSAGE'({commit}, {labelId, value}) {
        if (typeof (labelId) != "undefined") {
            const record = state.labels.find(element => element.id == labelId);
            if (record) {
                record.showMessage = value;
            }
        }

    },
    'SET_OPTION_ACTIVE'({commit}, {labelId, option}) {
        const record = state.labels.find(element => element.id == labelId);
        if (record) {
            record.print_options[option.parent].options.forEach(function (element) {
                element.isActive = 0;
            });
            option.isActive = 1;
        }
    },
    'SET_BACKGROUNDS'({commit}, {record}) {
        if (record) {
            if (typeof (record.print_options) != "undefined") {
                if (typeof (record.print_options['colors']) != "undefined") {
                    const recordActiveColor = record.print_options['colors'].options.find(element => element.isActive == 1)
                    if (recordActiveColor) {

                        if (typeof (recordActiveColor[['palette_colors']]) != "undefined") {
                            record.backgroundcolors = [];
                            record.current_color = recordActiveColor['palette_colors'][0];
                            recordActiveColor['palette_colors'].forEach(function (index, element) {
                                if (typeof (record.defaultEditorColors[index]) != "undefined") {
                                    record.backgroundcolors.push(record.defaultEditorColors[index]);
                                }
                            });
                        }

                        store.commit('SET_BACKGROUND_COLOR', {
                            record: record,
                            backColorId: record.current_color
                        })

                    }
                }
            }
        }
    },
    'SET_MASTER_TEXT'({commit}, {labelId}) {
        var record = state.labels.find(element => element.id == labelId);
        var label = record;
        var totalLines = 0;
        if (record) {
            if (parseInt(record.use_master_block)) {
                if (typeof (record.lines) != "undefined") {
                    record.lines.forEach(function (element) {
                        if (!parseInt(element.masterBlock)) {
                            $jQuery.printqFitText.adjustText(element, record);
                            if (element['fontsize'] < element['min_font_size']) {
                                element.textIsCut = 1
                            } else {
                                element.textIsCut = 0;
                            }
                        }

                    });
                    var masterBlocks = [];
                    var l = [];
                    var isCompleted = 0;

                    record.lines.reverse().forEach(function (element) {
                        if (!parseInt(element.masterBlock) && !(element.copy.length)) {
                            totalLines++;

                            if (element.text.length > 0 || element.placeholder.length > 0) {
                                isCompleted = 1;
                            }
                            if (isCompleted) {

                                var realLeft = parseFloat(element['pdf_width'] * element.left / element['page_width']) + parseFloat(element['TrimBoxH']);
                                var newTop = parseFloat(element['pdf_height'] - (element['pdf_height'] * element.top / element['page_height']) - (element['pdf_height'] * element['height'] / element['page_height'])) + parseFloat(element['TrimBoxW'])
                                element['realTop'] = newTop - element.topAdjust;
                                element['realLeft'] = realLeft;
                                var pblockHeight = parseFloat(element['pdf_height'] * element['height'] / element['page_height']).toFixed(2);
                                element['pblockHeight'] = pblockHeight;
                                l.push({
                                    'text': element.text.length ? element.text : "&nbsp;",
                                    'fontsize': element.fontsize,
                                    'font': element.font,
                                    'block_name': element.block_name,
                                    'placeholder': element.placeholder,
                                    'real_height': element.real_height,
                                    'pblockHeight': pblockHeight,
                                    'alignment': element.alignment,
                                    'line': element,
                                    'top': element.topAdjust,
                                    'page_resize_percentageH': element.page_resize_percentageH
                                });
                            }
                        } else {
                            element.text = '';
                            masterBlocks.push(element);
                        }
                    });

                    record.lines.reverse()
                    var no_lines = l.length;
                    var line_procent = 100 / totalLines;
                    var editprocent = line_procent * no_lines;
                    var emptyProcent = 100 - editprocent;
                    var top = 0;
                    var mBlock = [];
                    l.reverse().forEach(function (element, index) {
                        top = emptyProcent / 2 + (line_procent / 2) + (line_procent * index);
                        var text = element.text;

                        if (text.length == 0 || text == "&nbsp;") {
                            text = element.placeholder;
                        }

                        masterBlocks.forEach((function (index, l) {
                            return function (masterBlock, master_i) {
                                if (!parseInt(label.use_icon) && parseInt(masterBlock.master_type))
                                    mBlock = masterBlock;
                                if (parseInt(label.use_icon) && !parseInt(masterBlock.master_type) && !Object.keys(mBlock).length)
                                    mBlock = masterBlock;


                                var paddingTop = 0;
                                var paddingBottom = 0;
                                if (typeof (label.fontCorrections[masterBlock.font]) != "undefined") {
                                    if (typeof (label.fontCorrections[masterBlock.font][Math.round(parseFloat(element.fontsize))]) != "undefined") {
                                        paddingTop = label.fontCorrections[masterBlock.font][Math.round(parseFloat(element.fontsize))][0];
                                        paddingBottom = label.fontCorrections[masterBlock.font][Math.round(parseFloat(element.fontsize))][1];
                                    }
                                }
                                if (index == 0) {
                                    paddingTop = 0;
                                }
                                if (index == l.length - 1) {
                                    paddingBottom = 0;
                                }
                                var minHeight ="";
                                if(!text.length){
                                    minHeight ="min-height:"+element.real_height + "px;";
                                }
                                if (!masterBlock.copy.length)
                                    masterBlock.text += "<span class='" + record.uniqueId + element.block_name + "' style='text-align:" + masterBlock.alignment + ";max-height:" + (element.real_height) + "px;top:" + top + "%; font-size:" + element.fontsize + "pt;margin-bottom:" + paddingBottom + "pt;"+minHeight+"margin-top:" + paddingTop + "pt'>" + text.replace("<", "") + "</span>";
                            }
                        })(index, l));
                    });
                    l.forEach(function (element, index) {
                        var masterBlock = mBlock;
                        var masterDiv = $jQuery('#' + masterBlock['uniqueId']);
                        masterDiv.addClass('visible');
                        var span = masterDiv.find('span.' + label.uniqueId + element.block_name);
                        var masterBounding = masterDiv.get(0).getBoundingClientRect();
                        var rw = parseFloat(masterBlock.page_resize_percentageW) / 100;
                        var rh = parseFloat(masterBlock.page_resize_percentageW) / 100;
                        if (span.length) {
                            var page = span.parents('.page');
                            var scale = page.data('scale');
                            if (typeof (scale) == "undefined") {
                                scale = 1;
                            }
                            var spanBounding = span.get(0).getBoundingClientRect();
                            var pageBlockContainerBounding = span.parents('.page_blocks_container').get(0).getBoundingClientRect();

                            span.addClass('removeDisplay');
                            var cbGetter = $jQuery("#cbGetter");
                            cbGetter.html((span.text()));
                            cbGetter.css({
                                'font-family': '"' + element.font + '"',
                                'font-size': element.fontsize + "pt"
                            });
                            cbGetter.get(0).style.fontFamily = element.font;
                            cbGetter.get(0).style.fontSize = element.fontsize + "pt"
                            var cbGetterBounding = cbGetter.get(0).getBoundingClientRect();
                            var diff = (spanBounding.height - cbGetterBounding.height * rh) / 2;
                            var bottomText = (pageBlockContainerBounding.bottom - spanBounding.bottom)/scale + diff;
                            var params = {
                                font: element.font,
                                font_size: element.fontsize
                            };
                            var fontF = getFontForge(params);
                            var topText = bottomText + fontF.bottom/scale ;
                            var diffLeft = 0
                            if (masterBlock['alignment'] == "center") {
                                diffLeft = (masterBounding.width/scale - cbGetterBounding.width * rw) / 2;
                            }

                            var textLeft = (spanBounding.left - pageBlockContainerBounding.left)/scale +diffLeft;
                            var newTop = parseFloat(masterBlock['pdf_height']) * topText / parseFloat(masterBlock['page_height']) + parseFloat(masterBlock['TrimBoxW'])
                            var realLeft = parseFloat(parseFloat(masterBlock['pdf_width']) * (textLeft) / parseFloat(masterBlock['page_width'])) + parseFloat(masterBlock['TrimBoxH']);
                            span.removeClass('removeDisplay');
                            var heightSpan = (span.get(0).getBoundingClientRect().height / scale) / ((parseFloat(element.page_resize_percentageH)) / 100);
                            var pblockHeight = parseFloat(masterBlock['pdf_height'] * heightSpan / masterBlock['page_height']).toFixed(2);
                        } else {
                            newTop = 0;
                            realLeft = 0;
                            pblockHeight = 0;
                        }
                        element.line['realLeft'] = realLeft;
                        element.line['realTop'] = newTop;
                        element.line['pblockHeight'] = pblockHeight;
                        masterDiv.removeClass('visible');
                    })
                }
            } else {
                if (typeof (record.lines) != "undefined") {
                    record.lines.forEach(function (element) {
                            $jQuery.printqFitText.adjustText(element, record)
                            if (element['fontsize'] < element['min_font_size']) {
                                element.textIsCut = 1
                            } else {
                                element.textIsCut = 0;
                            }
                            var masterBlock = element;
                            var rw = parseFloat(element.page_resize_percentageW) / 100;
                            var rh = parseFloat(element.page_resize_percentageW) / 100;
                            var span = $jQuery('#' + element['uniqueId']);
                            var masterBounding = span.get(0).getBoundingClientRect();
                            var page = span.parents('.page');
                            var scale = page.data('scale');
                            if (typeof (scale) == "undefined") {
                                scale = 1;
                            }
                            var spanBounding = span.get(0).getBoundingClientRect();
                            var pageBlockContainerBounding = span.parents('.page_blocks_container').get(0).getBoundingClientRect();

                            span.addClass('removeDisplay');
                            var cbGetter = $jQuery("#cbGetter");
                            cbGetter.html((span.text()));
                            cbGetter.css({
                                'font-family': '"' + element.font + '"',
                                'font-size': element.fontsize + "pt"
                            });
                            var cbGetterBounding = cbGetter.get(0).getBoundingClientRect();
                            var diff = (spanBounding.height - cbGetterBounding.height * rh) / 2;
                        var bottomText = (pageBlockContainerBounding.bottom - spanBounding.bottom) / scale + diff;
                            var params = {
                                font: element.font,
                                font_size: element.fontsize
                            };
                            var fontF = getFontForge(params);
                            var topText = bottomText + fontF.bottom / scale;
                         var diffLeft = 0
                           if (element['alignment'] == "center") {
                            diffLeft = (masterBounding.width/scale - cbGetterBounding.width * rw) / 2;
                            }
                            var textLeft = (spanBounding.left - pageBlockContainerBounding.left)/scale +diffLeft;
                            var newTop = parseFloat(masterBlock['pdf_height']) * topText / parseFloat(masterBlock['page_height']) + parseFloat(masterBlock['TrimBoxW'])
                            var realLeft = parseFloat(parseFloat(masterBlock['pdf_width']) * (textLeft) / parseFloat(masterBlock['page_width'])) + parseFloat(masterBlock['TrimBoxH']);
                            span.removeClass('removeDisplay');
                            var heightSpan = (span.get(0).getBoundingClientRect().height / scale) / ((parseFloat(element.page_resize_percentageH)) / 100);
                            var pblockHeight = parseFloat(masterBlock['pdf_height'] * heightSpan / masterBlock['page_height']).toFixed(2);
                            span.removeClass('removeDisplay');
                            element['realTop'] = newTop;
                            element['realLeft'] = realLeft;
                            element['pblockHeight'] = parseFloat(element['pdf_height'] * element['height'] / element['page_height']).toFixed(2);
                        }
                    );
                }
            }
        }
    }
};
const actions = {
    initLabels: ({commit}) => {
        commit('SET_LABELS', labels);
    },
    changeFont: ({commit}, params) => {
        commit('SET_LINE_FONT', params);
    },
    changeClipart: ({commit}, params) => {
        commit('SET_CLIPART_URL', params);
    },
    changeColorText: ({commit}, params) => {
        commit('SET_LINE_COLOR', params);
    },
    initPage: ({commit}, params) => {
        var activePage = $jQuery(".product-single .label_page_" + params.label.uniqueId);
        var pagesContainer = $jQuery(".product-single .pages_" + params.label.uniqueId);
        if (activePage) {
            var p = {
                activePage: activePage,
                pagesContainer: pagesContainer
            }
            store.dispatch('adjustPage', p)
        }
        var activePage = $jQuery("#lightbox-product .label_page_" + params.label.uniqueId);
        var pagesContainer = $jQuery("#lightbox-product .pages_" + params.label.uniqueId);
        if (activePage) {
            var p = {
                activePage: activePage,
                pagesContainer: pagesContainer
            }
            store.dispatch('adjustPage', p)
        }
        var print_setup = document.querySelector(".print-setup.print_setup");
        if (print_setup) {
            var labelsContainer = document.querySelector(".labelsContainer");
            print_setup.style.height = labelsContainer.offsetHeight + "px";
        }
        var svgWrappers = $jQuery(".svgWrapper");
        $jQuery.each(svgWrappers, function (index, item) {
            var _self = $jQuery(item);
            var svg = _self.find("svg");
            if (svg.length) {
                _self.height(svg.height());
            }
        })


    },
    adjustPage: ({commit}, params) => {
        var activePage = params.activePage;
        activePage.data('scale', 1);
        var pagesContainer = params.pagesContainer;
        if (activePage.length) {
            activePage.css({
                'transform': '',
                'transform-origin': ''
            });
            var activePageBounding = activePage.get(0).getBoundingClientRect();
            var pagesContainerBounding = pagesContainer.get(0).getBoundingClientRect();
            var widthDiff = pagesContainerBounding.width / activePageBounding.width;
            var heightDiff = (pagesContainerBounding.height) / (activePageBounding.height);
            var diff = 0;
            var left = '';
            var top = '';
            var mLeft = '';
            var mTop = '';
            if (widthDiff < 1 && heightDiff < 1) {
                diff = Math.min(widthDiff, heightDiff);
            } else {
                if (widthDiff < 1) {
                    diff = widthDiff;
                }
                if (heightDiff < 1) {
                    diff = heightDiff;
                }
            }
            if (diff) {
                left = '0';
                top = '0';
                mLeft = parseInt((pagesContainerBounding.width - activePageBounding.width * diff) / 2);
                mTop = parseInt(((pagesContainerBounding.height) - (activePageBounding.height) * diff) / 2);
                if (mLeft < 0) {
                    mLeft = 0;
                }
                if (mTop < 0) {
                    mTop = 0;
                }
                activePage.css({
                    'transform': 'scale(' + diff + ') translate(-50%,-50%)',
                    'transform-origin': 'left top 0px'
                });
                activePage.data('scale', diff)
            }


        }
    },
    changeBackgroundColor: ({commit}, params) => {
        commit('SET_BACKGROUND_COLOR', params);
    },
    setLabelReady: ({commit}, params) => {
        commit('SET_LABEL_READY', params);
    },
    setOptionActive: ({commit}, params) => {
        const record = state.labels.find(element => element.id == params.labelId);
        commit('SET_OPTION_ACTIVE', params);
        commit('SET_BACKGROUNDS', {record: record});
    },
    setMasterText: ({commit}, params) => {
        commit('SET_MASTER_TEXT', params);
    },
    setShowMessage: ({commit}, params) => {
        commit('SET_SHOW_MESSAGE', params);
    },
    SETBACKGROUNDS: ({commit}, params) => {
        commit('SET_BACKGROUNDS', {record: params.record});
    },
    changeFormat: ({commit}, params) => {
        commit('CHANGE_FORMAT', {labelId: params.labelId, formatCode: params.formatCode});
    },
    saveFrame: ({commit}, params) => {
        commit('SAVE_FRAME', params);
    },
    generatePreview: ({commit}, params) => {
        commit('GENERATE_PREVIEW', params);
    }
};
const getters = {
    labels: state => {
        return state.labels;
    }
}
const computed = {
    getLabelById: function () {
        return 1;
    }

}
export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/labels.js